import React, { useState, useEffect, useRef } from "react";
import { updateUser } from "../../api-interactions/authentication";
import { getFamily, updateFamily } from "../../api-interactions/family";
import { getCookie } from "../../helperFunctions/cookie";
import { SignupJoinFamily } from "../signin-up/signup-join-family";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import "./family-settings.css";

export const FamilySettings = () => {
  const [editMode, setEditMode] = useState(false);
  let user = JSON.parse(localStorage.getItem("user"));

  const [successMsg, setSuccessMsg] = useState("");

  const familyNameRef = useRef();
  const allowMembersRef = useRef();
  const ownerRef = useRef();

  const jwt = getCookie();

  const [family, setFamily] = useState(
    JSON.parse(localStorage.getItem("family"))
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    getFamily(user);
    setFamily(JSON.parse(localStorage.getItem("family")));
  }, []);

  let userColor = "#000000";

  const isUserColor = (member) => {
    if (member.userName === user.userName) userColor = member.color;
  };

  const newSuccess = (message) => {
    setSuccessMsg(message);
    setTimeout(() => {
      setSuccessMsg("");
    }, 3000);
  };

  const changeColorHandler = (e) => {
    e.preventDefault();
    const newMember = family.members.filter((member) => {
      return member.userId === user._id;
    });
    const oldMembers = family.members.filter((member) => {
      return member.userId !== user._id;
    });
    newMember[0].color = e.target[0].value;
    updateFamily(jwt, user, { members: [...oldMembers, ...newMember] });
    newSuccess("Successfully changed color");
  };

  const leaveFamilyHandler = () => {
    updateUser({ familyId: "" }, user.userId);
    newSuccess("You left the family");
  };

  const updateFamilyHandler = () => {
    updateFamily(jwt, user, {
      owner: ownerRef.current.value,
      familyName: familyNameRef.current.value,
      canJoin: allowMembersRef.current.value,
    });
    setEditMode(false);
    setFamily(JSON.parse(localStorage.getItem("family")));
    newSuccess("Successfuly updated your family");
  };

  const removeMemberHandler = (memberToDelete) => {
    if (
      family.createdBy !== user.userName ||
      memberToDelete.userName === family.createdBy
    )
      return;
    const filteredMembers = family.members.filter((member) => {
      if (member.userName !== memberToDelete.userName) {
        return member;
      }
    });
    updateUser({ familyId: "" }, memberToDelete.userId);
    updateFamily(jwt, user, { members: filteredMembers });
    setFamily({ ...family, members: (family.members = filteredMembers) });
  };

  return (
    <>
      {user.familyId ? (
        <div className="change-settings-container">
          {successMsg && (
            <Snackbar open={true} autoHideDuration={6000}>
              <Alert severity="success">{successMsg}</Alert>
            </Snackbar>
          )}
          <div id="family-card">
            <h2 id="family-name">{family.familyName}</h2>
            <p>Code: {family.familyCode}</p>
          </div>
          <div id="family-settings-container">
            <div
              className="family-settings-section"
              id="general-family-settings"
            >
              <div id="members-settings">
                <h3>Members ({family.members.length})</h3>
                <div id="members-settings-container">
                  {family.members.map((member) => {
                    isUserColor(member);
                    return (
                      <div className="member">
                        <div
                          className="triangle"
                          style={{ borderLeft: "15px solid " + member.color }}
                        ></div>
                        <p
                          className="member-name"
                          onClick={() => removeMemberHandler(member)}
                        >
                          {member.userName}
                        </p>
                        {member.userName === user.userName && (
                          <span id="you-badge">YOU</span>
                        )}
                        {family.createdBy === member.userName && (
                          <span id="owner-badge">OWNER</span>
                        )}
                        <span id="amount-of-points-settings">
                          {member.amountOfPoints} points
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div
              className="family-settings-section"
              id="personal-family-settings"
            >
              <div id="family-settings">
                <div id="personal-info-header">
                  <h3>Settings: </h3>
                  {family.createdBy === user.userName && !editMode && (
                    <button
                      id="edit-personal-info-button"
                      onClick={() => setEditMode(true)}
                    >
                      EDIT
                    </button>
                  )}
                </div>
                <div id="settings-property-container">
                  <p className="settings-property">Familyname:</p>
                  {!editMode ? (
                    <p className="settings-property-info">
                      {family.familyName}
                    </p>
                  ) : (
                    <input
                      ref={familyNameRef}
                      className="change-property"
                      type="text"
                      defaultValue={family.familyName}
                    ></input>
                  )}
                  <p className="settings-property">Allow Members</p>
                  {!editMode ? (
                    <p className="settings-property-info">{family.canJoin}</p>
                  ) : (
                    <select
                      defaultValue={family.canJoin}
                      ref={allowMembersRef}
                      className="change-property"
                    >
                      <option value="public">Everyone can join</option>
                      <option value="invitation">Only on Invitation</option>
                      <option value="accept">You need to accept</option>
                    </select>
                  )}
                  <p className="settings-property">Owner</p>
                  {!editMode ? (
                    <p className="settings-property-info">{family.createdBy}</p>
                  ) : (
                    <input
                      ref={ownerRef}
                      className="change-property"
                      type="text"
                      defaultValue={family.createdBy}
                    ></input>
                  )}
                </div>
                <div id="personal-family-settings">
                  <h3>You:</h3>
                  <div className="member" id="member-me">
                    <div
                      className="triangle"
                      style={{ borderLeft: "15px solid " + userColor }}
                    ></div>
                    <p className="member-name">{user.userName}</p>
                    <form onSubmit={changeColorHandler}>
                      <input
                        type="color"
                        defaultValue={userColor}
                        id="color-picker"
                      />
                      <button type="submit" id="change-photo-button">
                        Change Color
                      </button>
                    </form>
                  </div>
                  <button id="leave-family-button" onClick={leaveFamilyHandler}>
                    Leave Family
                  </button>
                </div>
                {editMode && (
                  <div>
                    <button
                      onClick={updateFamilyHandler}
                      className="update-button"
                    >
                      UPDATE
                    </button>
                    <button
                      onClick={() => setEditMode(false)}
                      className="cancel-button"
                    >
                      CANCEL
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div id="join-family-container">
          <SignupJoinFamily />
        </div>
      )}
    </>
  );
};
